import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=64ca7fd5&scoped=true&"
import script from "./VideoDetail.vue?vue&type=script&lang=js&"
export * from "./VideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=64ca7fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca7fd5",
  null
  
)

export default component.exports